import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EventTimelineIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.89 14.2651V16.1101H7.2975V14.2651H13.89ZM18.5475 18.9226V8.64011H5.4525V18.9226H18.5475ZM18.5475 3.93761C19.0575 3.93761 19.5 4.12511 19.875 4.50011C20.25 4.87511 20.4375 5.3176 20.4375 5.82761V18.9226C20.4375 19.4326 20.25 19.8751 19.875 20.2501C19.5 20.6251 19.0575 20.8126 18.5475 20.8126H5.4525C4.9275 20.8126 4.48125 20.6251 4.11375 20.2501C3.74625 19.8751 3.5625 19.4326 3.5625 18.9226V5.82761C3.5625 5.3176 3.74625 4.87511 4.11375 4.50011C4.48125 4.12511 4.9275 3.93761 5.4525 3.93761H6.375V2.04761H8.265V3.93761H15.735V2.04761H17.625V3.93761H18.5475ZM16.7025 10.4851V12.3751H7.2975V10.4851H16.7025Z'
                fill='currentColor'
            />
        </>
    ),
})

EventTimelineIcon.displayName = 'EventTimelineIcon'
